import { useSubscription } from "@/context/SubscriptionContext";
import { PaymentOptions } from "@/components/PaymentOptions";
import { Vinti4Payments } from "@/components/Vinti4Payments";
import { PaymentFooter } from "@/components/PaymentLogos";
import { fmtDate } from "@/lib/format";
import { periodLabel } from "@/lib/pricing";
import { Badge } from "@/components/ui/badge";
import { Sparkle, CircleNotch } from "@phosphor-icons/react";

const BADGE = {
  active: ["Ativo", "border-emerald-200 bg-emerald-50 text-emerald-700"],
  trialing: ["Em teste", "border-blue-200 bg-blue-50 text-blue-700"],
  expired: ["Expirado", "border-red-200 bg-red-50 text-red-700"],
};

export function CurrentPlan() {
  const { entitlement: e } = useSubscription();
  if (!e) return null;
  const [label, cls] = BADGE[e.state] || BADGE.expired;
  return (
    <div className="rounded-xl border border-border bg-card p-5" data-testid="current-plan">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent text-primary"><Sparkle size={20} weight="fill" /></div>
          <div>
            <div className="font-semibold" data-testid="current-plan-name">
              {e.state === "active" ? `Plano ${e.plan_name}${e.months ? ` · ${periodLabel(e.months)}` : ""}${e.provider === "stripe" ? " · Cartão" : ""}` : e.state === "trialing" ? "Teste grátis" : "Plano expirado"}
            </div>
            <div className="text-sm text-muted-foreground" data-testid="current-plan-dates">
              {e.start_date && `Início ${fmtDate(e.start_date)} · `}
              {e.state === "expired" ? `Terminou em ${fmtDate(e.end_date)}` : `Termina em ${fmtDate(e.end_date)} (${e.days_left} dia(s))`}
            </div>
          </div>
        </div>
        <Badge variant="outline" className={cls} data-testid="current-plan-state">{label}</Badge>
      </div>
    </div>
  );
}

export default function MyPlan() {
  const { entitlement, refresh } = useSubscription();
  return (
    <div className="space-y-6" data-testid="my-plan-page">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Conta</p>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">O meu plano</h1>
      </div>
      {!entitlement ? (
        <div className="flex h-48 items-center justify-center"><CircleNotch size={26} className="animate-spin text-primary" /></div>
      ) : (
        <>
          <CurrentPlan />
          <PaymentOptions />
          <Vinti4Payments onChange={refresh} />
          <div className="pt-4"><PaymentFooter /></div>
        </>
      )}
    </div>
  );
}
